// The hub half of the per-worktree routing tripwire. All behavior lives in
// `worktree-binding.ts`; this file is the hub descriptor plus the named exports
// its call sites already use.

import { UUID_RE } from './utils.js';
import { createWorktreeBinding } from './worktree-binding.js';

const binding = createWorktreeBinding({
  filename: 'wayai-binding',
  // Pre-rename filename, from when this was called a "lock".
  legacyFilename: 'wayai-lock',
  isValidId: (id) => UUID_RE.test(id),
  noun: 'hub',
  idLabel: 'hub_id (must be a UUID)',
  unbindCommand: 'wayai unbind',
  useCommand: 'wayai use',
});

export const getBindingPath = binding.getBindingPath;
export const readBinding = binding.readBinding;
export const writeBinding = binding.writeBinding;
export const clearBinding = binding.clearBinding;
export const autoBindIfUnbound = binding.autoBindIfUnbound;
export const assertHubMatchesBinding = binding.assertMatchesBinding;
export const assertNoBindingBlocksHubCreation = binding.assertNoBindingBlocksCreation;
